// ACTIONS
export const ACTION_GET_USER_REQUEST = '@actions/USER/GET_DETAILS_REQUEST'
export const ACTION_GET_USER_SUCCESS = '@actions/USER/GET_DETAILS_SUCCESS'
export const ACTION_GET_USER_FAILURE = '@actions/USER/GET_DETAILS_FAILURE'

export const ACTION_SWITCH_ORGANIZATION_REQUEST = '@actions/USER/SWITCH_ORGANIZATION_REQUEST'
export const ACTION_SWITCH_ORGANIZATION_SUCCESS = '@actions/USER/SWITCH_ORGANIZATION_SUCCESS'
export const ACTION_SWITCH_ORGANIZATION_FAILURE = '@actions/USER/SWITCH_ORGANIZATION_FAILURE'

export const ACTION_DOWNLOAD_AUDIT_LOG_REQUEST = '@actions/USER/DOWNLOAD_AUDIT_LOG_REQUEST'
export const ACTION_DOWNLOAD_AUDIT_LOG_SUCCESS = '@actions/USER/DOWNLOAD_AUDIT_LOG_SUCCESS'
export const ACTION_DOWNLOAD_AUDIT_LOG_FAILURE = '@actions/USER/DOWNLOAD_AUDIT_LOG_FAILURE'

export const ACTION_TOGGLE_CALL_DIALOG = '@actions/USER/TOGGLE_CALL_DIALOG'

// ERRORS
export const ERROR_GET_USER_SERVER = 'Failed to get user details. Please try again later.'
export const ERROR_SAVE_USER_SERVER = 'Failed to save user details. Please try again later.'
export const ERROR_GET_USERS_SERVER = 'Failed to get users details. Please try again later.'
export const ERROR_DELETE_USER_SERVER = 'Failed to remove user from the organization. Please try again later.'
export const ERROR_UPDATE_USER_SERVER = 'Failed to update user. Please try again later.'
export const ERROR_GET_ORGANIZATION_SERVER = 'Failed to get organization details. Please try again later.'
export const ERROR_SAVE_ORGANIZATION_SERVER = 'Failed to save organization details. Please try again later.'
export const ERROR_SWITCH_ORGANIZATION_SERVER = 'Failed switching to different organization. Please try again later.'
export const ERROR_SAVE_PASSWORD_SERVER =
  'Failed to save new password. Please make sure the details you entered are correct.'
export const ERROR_DOWNLOAD_AUDIT_LOG = 'Failed to download audit log. Please try again later.'
export const ERROR_INVITE_USER = 'Failed to invite User. Please try again later.'
export const ERROR_GET_INVITATIONS = 'Failed to get invitations. Please try again later.'
export const ERROR_DELETE_INVITATIONS = 'Failed to delete invitation. Please try again later.'
export const ERROR_INIT_TOTP = 'Failed to enable Two-Factor Authentication. Please try again later.'
export const ERROR_ENABLE_TOTP = 'Failed to enable Two-Factor Authentication. Please try again later.'
export const ERROR_DISABLE_TOTP = 'Failed to disable Two-Factor Authentication. Please try again later.'
export const ERROR_GET_RECOVERY_CODES = 'Failed to get recovery codes. Please try again later.'
export const ERROR_RESET_RECOVERY_CODES = 'Failed to reset recovery codes. Please try again later.'
export const ERROR_GET_SNIPPETS_SERVER = 'Failed to get user snippets. Please try again later.'
export const ERROR_SAVE_SNIPPET_SERVER = 'Failed to save user snippets. Please try again later.'
export const ERROR_GET_API_KEYS_SERVER = 'Failed to get API keys. Please try again later.'
export const ERROR_CREATE_API_KEY_SERVER = 'Failed to create API key. Please try again later.'
export const ERROR_UPDATE_API_KEY_SERVER = 'Failed to update API key. Please try again later.'
export const ERROR_DELETE_API_KEY_SERVER = 'Failed to delete API key. Please try again later.'
